import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import ManageRolesAndRightsJSON from '../../../json-data/manage-roles-and-rights.json';
import DataTable from 'react-data-table-component';
import { useState, useEffect, Fragment } from "react";
import { PiCaretDoubleRight } from "react-icons/pi";
import { configData } from "../../../config/systemconfigurationconstants";
import * as AWS from 'aws-sdk';
import lambdaConfig from "../../../hooks/lambdaConfig";
import UseLambdaInvocations from "../../../hooks/useLambdaInvocations";
import { ToastContainer, toast } from "react-toastify";
import { useEncryption } from '../../../customHooks/useEncryption';

const ManageRolesAndRights = () => {
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    // const rolesData = ManageRolesAndRightsJSON.RolesAndRights;
    // const allRightsData = ManageRolesAndRightsJSON.AllRights;
    const [rolesData, setRolesData] = useState([]);
    const [allRightsData, setAllRightsData] = useState([]);
    const [selectedRoleId, setSelectedRoleId] = useState(null);
    const [editedRoles, setEditedRoles] = useState(new Set());
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    // const [roles, setRoles] = useState(rolesData);

    // const selectedRole = Array.isArray(rolesData)
    //     ? rolesData.find(role => role.RoleMasterId === selectedRoleId) || null
    //     : null;


    console.log(rolesData);
    const [isDataView, setIsDataView] = useState(false);
    const [dotloader, setDotLoader] = useState(false);
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });

    useEffect(() => {
        if (!selectedRoleId && rolesData.length > 0) {
            setSelectedRoleId(rolesData[0].RoleMasterId);
            // setResetPaginationToggle(prev => !prev);       
        }


    }, [rolesData]);

    useEffect(() => {
        getManageRolesAndRights();



    }, [])
    const getManageRolesAndRights = async (saveMode = false) => {
        setDotLoader(true);
        try {
            const payload = {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
            };


            if (saveMode) {
                payload.RolesAndRights = rolesData;
            }

            const parsedBody = await invokeLambda(configData.GET_MANAGE_ROLES_RIGHTS, payload);

            if (parsedBody.Status) {
                if (!saveMode) {
                    // Only update state if we're fetching
                    setRolesData(
                        (parsedBody.RolesAndRights || []).map(role => ({
                            ...role,
                            Rights: Array.isArray(role.Rights) ? role.Rights : []
                        }))
                    );

                    setAllRightsData(parsedBody.AllRights || []);
                    setTimeout(() => {
                        setDotLoader(false);
                    }, 1000);
                } else {
                    toast.success("Changes Saved Successfully");
                    getManageRolesAndRights(); // Optionally re-fetch
                }
            } else {

                setDotLoader(false);
            }
        } catch (err) {
            console.error("Lambda error:", err);

            setDotLoader(false);
        }
    };
    // const saveRolesAndRights = async () => {
    //     try {
    //         const parsedBody = await invokeLambda(configData.UPDATE_MANAGE_ROLES_RIGHTS, {
    //             ...lambdaConfig,
    //             SecurityToken: localStorage.getItem('SecurityToken'),
    //             RoleRightsJSON: [
    //                 {
    //                     "RolesAndRights": [
    //                         {
    //                             "RoleName": "Processor",
    //                             "RoleId": 1,
    //                             "RIGHTS": [
    //                                 {
    //                                     "RightId": 1,
    //                                     "RightValue": 0
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 }]

    //         });

    //         if (parsedBody.Status) {
    //             toast.success("Role Added Successfully", {
    //                 position: "bottom-center",
    //                 autoClose: 2000,
    //                 hideProgressBar: true,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "colored",
    //             });
    //             setTimeout(() => setDotLoader(false), 1000);
    //             getManageRolesAndRights();

    //         } else {
    //             toast.error("Error in adding Role", {
    //                 position: "bottom-center",
    //                 autoClose: 2000,
    //                 hideProgressBar: true,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "colored",
    //             });
    //         }

    //     } catch (err) {



    //     }
    // }
    const saveRolesAndRights = async () => {
        setDotLoader(true);
        try {
            // ✅ Only send edited roles
            const changedRoles = rolesData.filter(role => editedRoles.has(role.RoleMasterId));

            const transformedRoles = changedRoles.map(role => ({
                RoleName: role.RoleName,
                RoleId: role.RoleMasterId,
                RIGHTS: role.Rights.map(right => ({
                    RightId: right.RightId,
                    RightValue: Number(right.RightValue)
                }))
            }));

            if (transformedRoles.length === 0) {
                // toast.info("No changes to save.");
                setDotLoader(false);
                return;
            }

            const payload = {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                RoleRightsJSON: [
                    {
                        RolesAndRights: transformedRoles
                    }
                ]
            };

            const parsedBody = await invokeLambda(configData.UPDATE_MANAGE_ROLES_RIGHTS, payload);

            if (parsedBody.Status) {
                toast.success("Changes Saved Successfully!", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });

                setEditedRoles(new Set());
                getManageRolesAndRights();
                setTimeout(() => setDotLoader(false), 1000);
            } else {
                setDotLoader(false);
            }

        } catch (err) {
            setDotLoader(false);
        }
    };


    const allrightscolumns = [
        {
            name: 'Action',
            selector: row => row.DisplayName,
            sortable: true,
        },
        {
            name: 'Permission',
            cell: row => {
                // ✅ Compute selectedRole from latest rolesData
                const selectedRole = rolesData.find(role => role.RoleMasterId === selectedRoleId);
                const rightForRole = selectedRole?.Rights?.find(r => r.RightId === row.RightId);

                const isEnabled = rightForRole?.RightValue == '1' ? true : false;
                console.log(rightForRole?.RightValue)

                return (
                    <Form.Check
                        type="switch"
                        id={`custom-switch-${row.RightId}`}
                        checked={isEnabled}
                        onChange={(e) => handlePermissionToggle(row.RightId, e)}
                    />
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const roleNames = [
        ...rolesData.map(r => r.RoleName),

    ];
    const columns = [
        {
            name: 'Rights',
            selector: row => row.DisplayName,
            // width: '220px',
            sortable: true,
        },
        ...roleNames.map(role => ({
            name: role,
            cell: row => {
                const isChecked = row[role];

                return (
                    <Form.Check
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleDataViewCheckboxToggle(role, row.RightId)}
                    />
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }))
    ];


    const handleDataViewCheckboxToggle = (roleName, rightId) => {
        setRolesData(prevRoles =>
            prevRoles.map(role => {
                if (role.RoleName === roleName) {
                    const existingRight = role.Rights.find(r => r.RightId === rightId);
                    const newRights = existingRight
                        ? role.Rights.map(r =>
                            r.RightId === rightId
                                ? { ...r, RightValue: r.RightValue === '1' ? '0' : '1' }
                                : r
                        )
                        : [...role.Rights, { RightId: rightId, RightValue: '1' }];

                    // ✅ Mark role as edited
                    setEditedRoles(prev => new Set(prev).add(role.RoleMasterId));

                    return {
                        ...role,
                        Rights: newRights
                    };
                }
                return role;
            })
        );
    };




    // const handlePermissionToggle = (rightId, e) => {
    //     setRolesData(prevRoles =>
    //         prevRoles.map(role => {
    //             if (role.RoleMasterId === selectedRoleId) {
    //                 const updatedRights = role.Rights.map(r =>
    //                     r.RightId === rightId
    //                         ? { ...r, RightValue: r.RightValue === '1' ? '0' : '1' }
    //                         : r
    //                 );

    //                 // ✅ Mark role as edited
    //                 setEditedRoles(prev => new Set(prev).add(role.RoleMasterId));

    //                 return { ...role, Rights: updatedRights };
    //             }
    //             return role;
    //         })
    //     );
    // };
    const handlePermissionToggle = (rightId, e) => {
        setRolesData(prevRoles =>
            prevRoles.map(role => {
                if (role.RoleMasterId === selectedRoleId) {
                    const existingRight = role.Rights.find(r => r.RightId === rightId);
                    const updatedRights = existingRight
                        ? role.Rights.map(r =>
                            r.RightId === rightId
                                ? { ...r, RightValue: r.RightValue === '1' ? '0' : '1' }
                                : r
                        )
                        : [...role.Rights, { RightId: rightId, RightValue: '1' }];

                    // ✅ Mark role as edited
                    setEditedRoles(prev => new Set(prev).add(role.RoleMasterId));

                    return { ...role, Rights: updatedRights };
                }

                return role;
            })
        );
    };

    const getMappedRightsData = (allRights, roles) => {
        return allRights.map(right => {
            const rightRow = { RightId: right.RightId, DisplayName: right.DisplayName };

            roles.forEach(role => {
                const roleRight = role.Rights.find(r => r.RightId === right.RightId);
                rightRow[role.RoleName] = roleRight ? roleRight.RightValue === "1" : false;
            });

            return rightRow;
        });
    };

    const mappedData = getMappedRightsData(allRightsData, rolesData);
    const screenWidth = window.innerWidth;
    let minHeight;

    if (screenWidth == 1920) {
        minHeight = '626px';
    } else if (screenWidth == 1680) {
        minHeight = '595px';
    } else if (screenWidth == 1600) {
        minHeight = '448px';
    } 
    // else if (screenWidth == 1280) {
    //     minHeight = '575px';
    // }
     else {
        minHeight = 'calc(100vh - 314px)';
    }
    const customStyles = {
        table: {
            style: {
                minHeight,
                backgroundColor: 'white',
                overflowY: 'auto',
            },
        },

    };
    return (
        <>
            <Row>
                <Col sm={12}>
                    <Form className='toggle-switch' style={{ marginTop: '-33px' }}>
                        <div className="d-flex align-items-center gap-2 float-end mb-1">
                            <Form.Label className={`mb-0 ${!isDataView ? 'gradient-text' : ''}`}>List View</Form.Label>
                            <Form.Check
                                type="switch"
                                id="custom-switch"
                                label={
                                    <span className={isDataView ? 'gradient-text' : ''}>
                                        Data View
                                    </span>
                                }
                                checked={isDataView}
                                onChange={() => setIsDataView(!isDataView)}
                            />
                        </div>
                    </Form>
                </Col>
            </Row>
            {!isDataView && (
                <Row>
                    <Col sm={3}>
                        <ListGroup>
                            {rolesData.map((role) => (
                                <ListGroup.Item
                                    key={role.RoleMasterId}
                                    active={role.RoleMasterId === selectedRoleId}
                                    // onClick={() => setSelectedRoleId(role.RoleMasterId)}
                                    onClick={() => {
                                        setSelectedRoleId(role.RoleMasterId);
                                        setResetPaginationToggle(prev => !prev);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >

                                    <span className={role.RoleMasterId === selectedRoleId ? 'role-text-animated' : ''}>
                                        <PiCaretDoubleRight /> {role.RoleName}
                                    </span>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </Col>
                    <Col sm={9}>
                        {dotloader ? (
                            <div className="d-flex justify-content-center align-items-center">
                                <div className="loader"></div>
                            </div>
                        ) : (
                            <DataTable
                                columns={allrightscolumns}
                                data={allRightsData}
                                dense
                                pagination
                                customStyles={customStyles}
                                paginationResetDefaultPage={resetPaginationToggle}
                            />
                        )}
                    </Col>

                </Row>
            )}
            {isDataView && (
                <Row>
                    <Col sm={12}>
                        {dotloader ? (
                            <div className="d-flex justify-content-center align-items-center">
                                <div className="loader"></div>
                            </div>
                        ) : (
                            <div className='dataview-grid'>
                                <DataTable
                                    columns={columns}
                                    data={mappedData}
                                    dense
                                    pagination
                                />
                            </div>
                        )}
                    </Col>



                </Row>
            )}
            <Row>
                <Col sm={12} className='text-end mt-2'>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        className="me-1"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={saveRolesAndRights}
                    >
                        Save
                    </Button>
                </Col>
            </Row>
        </>
    );
};

export default ManageRolesAndRights;